module.exports = __webpack_public_path__ + "img/o3.c84dbbae.png";